const STALE_WALLETCONNECT_SESSION_PATTERNS = [
  "No matching key. session topic doesn't exist",
  "No matching key. session topic doesn't exist",
];

const stringifyError = value => {
  if (!value) return '';
  if (typeof value === 'string') return value;
  if (value.message) return String(value.message);
  if (value.reason) return stringifyError(value.reason);
  try {
    return JSON.stringify(value);
  } catch {
    return String(value);
  }
};

export const isIgnorableWalletRuntimeError = error =>
  STALE_WALLETCONNECT_SESSION_PATTERNS.some(pattern => stringifyError(error).includes(pattern));

const suppressEvent = event => {
  if (typeof event.preventDefault === 'function') event.preventDefault();
  if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
};

export const installWalletRuntimeGuards = (target = window) => {
  if (!target?.addEventListener) return () => {};

  const handleUnhandledRejection = event => {
    if (isIgnorableWalletRuntimeError(event.reason)) suppressEvent(event);
  };

  const handleError = event => {
    if (isIgnorableWalletRuntimeError(event.error || event.message)) suppressEvent(event);
  };

  target.addEventListener('unhandledrejection', handleUnhandledRejection, true);
  target.addEventListener('error', handleError, true);

  return () => {
    target.removeEventListener('unhandledrejection', handleUnhandledRejection, true);
    target.removeEventListener('error', handleError, true);
  };
};
